'use client';

import { useEffect } from 'react';
import { useMatches, useNavigation } from 'react-router';
import { useConfig } from '@salesforce/storefront-next-runtime/config';
import { useSite } from '@salesforce/storefront-next-runtime/site-context';
import { persistPrimaryShoppingCategory, persistPrimaryShoppingPillar } from '@/lib/primary-shopping-category.client';
import { persistRecentlyViewedProduct } from '@/lib/recently-viewed.client';
import { resolveShoppingContext, type RouteDataWithShoppingContext } from '@/lib/shopping-context';
import type { AppConfig } from '@/types/config';

export function ShoppingContextCookieSync() {
    const matches = useMatches() as Array<{ data?: RouteDataWithShoppingContext }>;
    const navigation = useNavigation();
    const { site } = useSite();
    const config = useConfig<AppConfig>();
    const shoppingContext = resolveShoppingContext(matches);
    const primaryCategoryPath = shoppingContext?.primaryCategoryPath;
    const navigationPillar = shoppingContext?.navigationPillar;
    const recentlyViewedProductId = shoppingContext?.recentlyViewedProductId;
    const cookieDomain = site.cookies?.domain || config.cookies?.domain || undefined;

    useEffect(() => {
        if (navigation.state !== 'idle') {
            return;
        }

        if (primaryCategoryPath) {
            persistPrimaryShoppingCategory({
                domain: cookieDomain,
                path: primaryCategoryPath,
                siteId: site.id,
            });
        }

        if (navigationPillar) {
            persistPrimaryShoppingPillar({
                pillar: navigationPillar,
                domain: cookieDomain,
                siteId: site.id,
            });
        }

        if (recentlyViewedProductId) {
            persistRecentlyViewedProduct({
                domain: cookieDomain,
                productId: recentlyViewedProductId,
                siteId: site.id,
            });
        }
    }, [cookieDomain, navigation.state, navigationPillar, primaryCategoryPath, recentlyViewedProductId, site.id]);

    return null;
}
